import { render, staticRenderFns } from "./ProductCombinationConfiguration.vue?vue&type=template&id=2b24802c&scoped=true"
import script from "./ProductCombinationConfiguration.vue?vue&type=script&lang=ts"
export * from "./ProductCombinationConfiguration.vue?vue&type=script&lang=ts"
import style0 from "./ProductCombinationConfiguration.vue?vue&type=style&index=0&id=2b24802c&prod&lang=css"
import style1 from "./ProductCombinationConfiguration.vue?vue&type=style&index=1&id=2b24802c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b24802c",
  null
  
)

export default component.exports